import ActionsCell from './actions-cell';
import AddressCell from './address-cell';
import SelectionCell from './selection-cell';
import TitleSubtitleCell from './title-subtitle-cell';
import TitleWrapCell from './title-wrap-cell';
import TsCell from './ts-cell';

export default {
  Actions: ActionsCell,
  Address: AddressCell,
  Selection: SelectionCell,
  TitleSubtitle: TitleSubtitleCell,
  TitleWrap: TitleWrapCell,
  Ts: TsCell,
};
